export const coordOffset = {
    ruler: {
        x: 0,
        y: 80
    },
    protractor: {
        x: 0,
        y: 80
    },
    image: {
        x: 0,
        y: 80
    }
};

export const rulerYExtraOffset = 240;

export const initialToolsY = {
    ruler: 0,
    protractor: 0,
    image: 0
};
